<template>
  <a-social-sharing
    hashtags="finance_magnates,fm"
    twitter-user="finance_magnates"
    network="telegram"
    :url="sharingUrl"
    :title="title"
    :description="description"
    :quote="title"
    :open-in-iframe="openInIframe"
  >
    <a-icon
      v-bind="$attrs"
      is-button
      tabindex="-1"
      :original="true"
      :icon="$attrs.icon || ICON.SOCIAL_SQUARE_TELEGRAM"
    />
  </a-social-sharing>
</template>

<script>
import socialSharing from '../socialSharing'

export default {
  name: 'Telegram',
  mixins: [socialSharing]
}
</script>
